export function extraireNomFichier(url: string): string {
    if (!url) {
        return "";
    }

    try {
        const parsed = new URL(url);
        const depuisQuery = parsed.searchParams.get("file")
            ?? parsed.searchParams.get("fileName")
            ?? parsed.searchParams.get("FileName");
        if (depuisQuery) {
            return decoderNom(depuisQuery);
        }

        const segments = parsed.pathname.split("/").filter(Boolean);
        const dernier = segments[segments.length - 1] ?? "";
        if (dernier && !dernier.toLowerCase().endsWith(".aspx")) {
            return decoderNom(dernier);
        }
    } catch {
        // URL relative ou invalide : on retombe sur le chemin brut.
    }

    const sansQuery = url.split("?")[0];
    const dernier = sansQuery.substring(sansQuery.lastIndexOf("/") + 1);
    return decoderNom(dernier);
}

function decoderNom(valeur: string): string {
    const brut = valeur.replace(/\+/g, " ").trim();
    try {
        return decodeURIComponent(brut);
    } catch {
        return brut;
    }
}
